module.exports = __webpack_public_path__ + "static/media/checkMark.871c338a.svg";